import React from 'react';
import { Database, Search, Link2, Layers, Share2, BarChart3, Settings, Code2 } from 'lucide-react';

const features = [
  { icon: Database, title: "CMS Integration", desc: "Seamless content management and website integration." },
  { icon: Search, title: "SEO Ready", desc: "Improve search engine ranking with optimized structure." },
  { icon: Link2, title: "API Connectivity", desc: "Robust and secure backend data communication." },
  { icon: Layers, title: "Extensibility", desc: "Easily add new features and scale your platform." },
  { icon: Share2, title: "Social Sharing", desc: "Integrate social media for better user engagement." },
  { icon: BarChart3, title: "Advanced Analytics", desc: "Data-driven insights to track user performance." },
  { icon: Settings, title: "ESS Solutions", desc: "Custom enterprise solutions for your business." },
  { icon: Code2, title: "Code Connectivity", desc: "Clean, maintainable code for long-term growth." }
];

const KeyFeatures = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
     <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* 2. GRID OVERLAY */}
      <div className="absolute inset-0 opacity-[0.04] dark:opacity-[0.03]" 
           style={{ 
             backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', 
             backgroundSize: '60px 60px' 
           }}>
      </div>

      {/* 3. CONTENT WRAPPER */}
      <div className="relative z-10 max-w-7xl mx-auto">
         <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
           Our Key  {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
             Features
            </span>
          </h2>
      <p className="myparagraph text-gray-500">
  High-performance development tools and modern features.</p>
      </div>
       
       

        {/* 3x3 Grid with Horizontal Card Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((item, i) => (
            <div key={i} className="flex items-start p-6 bg-white dark:bg-[#1a1a1a] rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md transition-all duration-300">
              {/* Icon on Left */}
              <div className="flex-shrink-0 w-12 h-12 bg-orange-50 dark:bg-orange-900/20 rounded-xl flex items-center justify-center mr-4">
                <item.icon className="w-6 h-6 text-primary" />
              </div>
              
              {/* Content on Right */}
              <div>
                <h3 className="text-lg font-bold mb-1 text-gray-900 dark:text-white">
                  {item.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;